<template>
	<div class="wrapper">
		<div class="head"><van-nav-bar title="扫码充值" /></div>
		<div class="content">
			<div style="width: 100%;text-align: center;height: 40px;line-height: 40px;font-size: 18px;font-weight: 600;">{{shopName}}</div>
			<div class="inp">
				<div class="item tel" v-if="!userTel">
					<p class="title">手机号</p>
					<p><input type="number" v-model="valueTel" placeholder="请输入手机号" /></p>
				</div>
				<div class="item">
					<p class="title">输入金额</p>
					<p><input type="number" v-model="valuePrice" placeholder="请输入金额" /></p>
				</div>
			</div>
		</div>

		<div class="footer"><van-button style="background:#00BFFF;border-color:#00BFFF" type="danger" round size="large" @click="handlePay">立即支付</van-button></div>
	</div>
</template>

<script>
import { verificationUserService } from '../service/userService';
import { mapState, mapActions } from 'vuex';
import { Toast, Dialog } from 'vant';
import { getUrlParamsTools } from '../util/tools';
import Cookies from 'js-cookie';
import { isWeixinOrAlipayTools } from '../util/tools';
import { getShopName } from '../service/basicService.js';

export default {
	name: 'shopScanZfb',
	data() {
		return {
			valueTel: '',
			valuePrice: '',
			type: '3', //0付款，1充值，2会员卡消费,3扫码充值
			shopId: null,
			balance: 0, //可用余额
			cashCoupon: 0, //代金券总数
			checkedCashCoupon: false, //是否使用代金券
			total: 0, //使用现金总数
			lock: true,
			shopName: null
		};
	},
	created() {
		this.shopId = this.$route.params.shopId;
		this.localTel = localStorage.getItem('u_pay_tel');
		if (this.localTel) {
			this.valueTel = this.localTel;
		}
		this.getThisShopName();
	},
	watch: {
		valuePrice(newVal) {
			this.total = this.valuePrice ? parseFloat(this.valuePrice).toFixed(2) : 0;
		},
		valueTel(value) {
			if (value !== '' && value !== null && !/^1[3456789]\d{9}$/.test(value)) {
				return '';
			} else {
				if (this.localTel != value) {
					localStorage.removeItem('u_pay_tel');
					this.localTel = '';
					this.cashCoupon = 0;
					this.balance = 0;
				}
				if (!this.localTel && value) {
					verificationUserService(value)
						.then(res => {
							if (res.status === 1) {
								Dialog.confirm({
									title: '提示',
									message: '你的账号未登录，是否前去登录'
								})
									.then(() => {
										sessionStorage.setItem('p_a_tel', this.valueTel);
										this.$router.push({
											name: 'userLoginAlipay'
										});
									})
									.catch(() => {});
							} else {
								localStorage.setItem('u_pay_tel', value);
							}
						})
						.catch(err => {
							console.log(err);
						})
						.finally(() => {});
				}
			}
		}
	},
	methods: {
		...mapActions(['setPrice', 'setUserTel']),
		getThisShopName(){
			getShopName(this.shopId)
				.then(res => {
					if (res.status === 1) {
						this.shopName = res.datas;
					} else {
						Toast(res.msg);
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		//支付
		handlePay() {
			if (!this.lock) {
				return;
			}
			if (!this.shopId) {
				Toast('商家ID不存在，请联系工作人员');
				return;
			}
			if (this.valuePrice.length == 0) {
				Toast('请输入金额');
				return;
			}
			if (this.valuePrice < 0.1) {
				Toast('输入金额大于0.1');
				return;
			}
			if (this.userTel && this.userTel != '0') {
				this.valueTel = this.userTel;
			} else {
				if (this.valueTel.length != 11) {
					Toast('请输入手机号');
					return;
				}
			}
			if (this.valuePrice <= 0) {
				Toast('支付金额输入有误');
				return;
			}
			this.handelAliPay();
		},

		//支付宝支付
		handelAliPay() {
			let total = this.valuePrice, //总金额
				cash = 0, //使用代金券数量
				price = 0; //使用现金数量
			// if (this.checkedCashCoupon) {
			// 	//使用了代金券
			// 	price = total - this.cashCoupon > 0 ? total - this.cashCoupon : 0;
			// 	cash = total - this.cashCoupon > 0 ? this.cashCoupon : total;
			// } else {
				//使用现金数量等于输入的金额
				price = this.valuePrice;
			// }
			window.location.href = 'https://www.shoudaole.cn/api/sdl/underLineAliPay?tel=' + this.valueTel + '&amount=' + price + '&shop_id=' + this.shopId + '&type=' + this.type + '&use_djj=' + cash + '&total_sum=' + total ;
		}
	},
	computed: {
		// ...mapState({
		// 	userId: state => state.userInfo.userId,
		// 	userTel: state => state.userInfo.userTel,
		// 	userPrice: state => state.userInfo.userPrice,
		// 	openId: state => state.userInfo.openId
		// })
	}
};
</script>

<style scoped lang="scss">
.wrapper {
	background-color: #ffffff !important;
	.content {
		background-color: #ffffff !important;
		.inp {
			padding: 20px;
			box-sizing: border-box;
			.item {
				&:nth-child(1) {
					margin-bottom: 20px;
				}
				.title {
					color: #202020;
					font-size: 14px;
					margin-bottom: 10px;
				}
				input {
					height: 40px;
					border: 1px solid rgba(208, 208, 208, 1);
					border-radius: 5px;
					width: 100%;
					padding: 0 5px;
					box-sizing: border-box;
				}
			}
			.balance {
				margin-top: 5px;
				height: 20px;
				span {
					color: #ef000c;
				}
			}
		}
		.option {
			.text {
				padding: 10px 0;
				border-bottom: 1px solid rgba(240, 240, 240, 1);
				span {
					margin-left: 20px;
					color: #202020;
					font-size: 14px;
				}
			}
			.option-box {
				padding: 10px 20px;
				box-sizing: border-box;
				.option-item {
					padding: 15px 0;
					border-bottom: 1px solid rgba(240, 240, 240, 1);
					display: flex;
					align-items: center;
					.icon-img {
						flex: 10%;
						img {
							width: 25px;
							height: 25px;
						}
					}
					.title {
						flex: 80%;
					}
					.radio {
						flex: 10%;
					}
				}
			}
		}
	}
	.footer {
		padding: 30px 20px;
		box-sizing: border-box;
	}
}
</style>
<style scoped>
.van-button--large {
	height: 40px;
	line-height: 40px;
}
</style>
